const columns = (teams, templates) => [
  {
    name: 'Name',
    selector: (row) => row.attributes.full_name,
    sortable: true,
    searchable: true,
    exportable: true,
  },
  {
    name: 'TA',
    selector: (row) => row.attributes.assessments_count,
    sortable: true,
    exportable: true,
  },
  {
    name: 'AI',
    selector: (row) => row.attributes.ai_sessions_count,
    sortable: true,
    exportable: true,
  },
  {
    name: 'Coaching',
    selector: (row) => row.attributes.coaching_sessions_count,
    sortable: true,
    exportable: true,
  },
  {
    name: 'Active',
    selector: (row) => row.attributes.active_last_90_days,
    filter: {
      type: 'SINGLE_SELECT',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ],
    },
    exportable: true,
  },
  {
    name: 'Work Email',
    selector: (row) => row.attributes.email,
    sortable: true,
    searchable: true,
    exportable: true,
  },
  {
    name: 'Team',
    selector: (row) => row.attributes.team,
    sortable: true,
    filter: {
      type: 'MULTI_SELECT',
      options: teams ? teams.map((item) => item.attributes.title) : [],
    },
    exportable: true,
  },
  {
    name: 'Invited On',
    selector: (row) => row.attributes.invited_on_timestamp,
    format: (row) => row.attributes.invited_on_formatted,
    sortable: true,
    exportable: true,
  },
  {
    name: 'Program',
    selector: (row) => row.attributes.programs.map((program) => program.title).join(', '),
    sortable: false,
    exportable: true,
    filter: {
      type: 'MULTI_SELECT',
      options: templates,
    },
  },
];

export default columns;
